import { render, staticRenderFns } from "./modalEditarDireccion.vue?vue&type=template&id=b1a45a16&"
import script from "./modalEditarDireccion.vue?vue&type=script&lang=js&"
export * from "./modalEditarDireccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports